import { isAbsoluteUrl } from '../../../../../../../../utils/locationUtils';

export const JIRA_PROJECT_LINK_PREFIX = 'https://jira.wixpress.com/projects/';

export const getJiraProjectLink = (jiraProject) => {
  if (!jiraProject || isAbsoluteUrl(jiraProject)) {
    return jiraProject;
  }
  return `${JIRA_PROJECT_LINK_PREFIX}${jiraProject}`;
};
